import { useMemo } from 'react'

import { useBuildPendingStateChangeProps } from '~/components/txn-display/state-change/hooks/useBuildPendingStateChangeProps'
import { TxnData } from '~/components/txn-display/state-change/types'
import { runTenderlySimulation } from '~/components/txn-display/state-change/utils/simulation'
import { getChain } from '~/constants/chains'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'

export function useRunTenderlySimulation({
  transaction,
  txnData,
}: {
  transaction?: OrgRegularTransaction | PublicRegularTransaction
  txnData?: TxnData
}): (() => Promise<string | undefined>) | undefined {
  const { smartAccountAddress, chainId, calls, transactionId } =
    useBuildPendingStateChangeProps({ transaction, txnData })

  return useMemo(() => {
    if (!smartAccountAddress || !chainId || !calls?.length) return undefined
    if (!getChain(chainId)?.supportsTenderly) return undefined

    return () =>
      runTenderlySimulation({
        smartAccountAddress,
        chainId,
        calls,
        transactionId,
      })
  }, [smartAccountAddress, chainId, calls, transactionId])
}
